export const formatDate = (date?: string | null | undefined) => {
  return date ? new Date(date).toISOString().slice(0, 16) : new Date().toISOString().slice(0, 16);
};
